import ServiceWrapper, { type ServiceOptions } from "@utils/ServiceWrapper";
import { SAE_ACTION_CONTROLS, SAE_OPT_OUTS_BY_STUDENT } from "@const/SaeConst";

interface SaeDaoOptions {
    action: string;
    schoolYearKey?: number | string | null;
    signal?: AbortSignal;
    studentNumber?: number | string | null;
}

/**
 * Data Access Object for the Student Assessment Excusals API.
 */
const SaeDao = <T = unknown>(options: SaeDaoOptions): Promise<{ data: T }> | null => {
    const { action, schoolYearKey, studentNumber } = options;

    const requestOptions: ServiceOptions = { url: "", method: "GET" };

    const actionConfig: Record<string, Partial<ServiceOptions>> = {
        saeActionControlsRead: { method: "GET", url: `${SAE_ACTION_CONTROLS}/${schoolYearKey}/index.json` },
        saeOptOutsByStudentRead: {
            method: "GET",
            url: `${SAE_OPT_OUTS_BY_STUDENT}/${studentNumber}/${schoolYearKey}/index.json`
        }
    };

    const config = actionConfig[action];
    if (!config) {
        const error = new Error(`SaeDao: Invalid action "${action}" provided`);
        console.error("SaeDao: Invalid action provided");
        throw error;
    }

    return ServiceWrapper.serviceCall({
        options: { ...requestOptions, ...config }
    }) as Promise<{ data: T }>;
};

export default SaeDao;
